import { useQuery } from "@tanstack/react-query";

// const url = process.env.REACT_APP_URL_DIR + "user";
const urlProd = process.env.REACT_APP_URL_DIR + "gasto";

export function GetGastos() {
   const token = localStorage.getItem("token");
   const { data } = useQuery({
      queryKey: ["Gasto"],
      queryFn: () =>
         fetch(urlProd, {
            headers: {
               Authorization: `Bearer ${token}`,
            },
         }).then((res) => res.json())
   });

   return data;
}

export function GetGastosIns() {
   const token = localStorage.getItem("token");
   const { data } = useQuery({
      queryKey: ["Gasto"],
      queryFn: () =>
         fetch(urlProd, {
            headers: {
               Authorization: `Bearer ${token}`,
            },
         }).then((res) => res.json())
   });

   return data;
}
